import { IDiscoverMore } from "../../ISearch";

export const discoverMoreSv: Array<IDiscoverMore> = [
  {
    title: "Bästa proteinrika maten för viktnedgång",
    href: "/se/proteinrik-mat/livsmedlen",
    imageSrc:
      "https://i.dietdoctor.com/wp-content/uploads/2021/10/The-best-high-protein-foods-for-weight-loss-1.jpg?auto=compress%2Cformat&w=150&h=112&fit=crop"
  },
  {
    title: "Kom igång med proteinrik kost",
    href: "/se/proteinrik-mat",
    imageSrc:
      "https://i.dietdoctor.com/wp-content/uploads/2021/10/How-to-get-started-on-a-high-protein-diets.jpg?auto=compress%2Cformat&w=150&h=112&fit=crop"
  }
];
